import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';
import { GET_NOTIFICATIONS, VIEW_ALL_NOTIFICATIONS } from '../../service/graphql/notificationQuery';
import {
  IGetNotificationsPayload,
  IGetNotificationResponse,
  INotification,
  getNotificationsFailure,
  getNotificationsRequest,
  getNotificationsSuccess,
  viewWebNotificationsSuccess,
  viewWebNotifications,
  viewWebNotificationsFailure,
} from './notificationSlice';

import { IGraphQLResponse } from '../../types/commonTypes';
import client from '../../service/graphql';
import { updateChatCount } from '../chat/chatSlice';

function* watchGetNotifications(action: PayloadAction<IGetNotificationsPayload>) {
  try {
    const { coachId, skip, take, searchQuery, isViewed } = action.payload;
    const variables: {
      coachId: string;
      skip: number;
      take: number;
      searchQuery?: string;
      isViewed?: boolean;
    } = { coachId, skip, take };
    if (searchQuery !== undefined) {
      variables.searchQuery = searchQuery;
    }
    if (isViewed !== undefined) {
      variables.isViewed = isViewed;
    }
    const response: IGraphQLResponse<IGetNotificationResponse> = yield call(client.query, {
      query: GET_NOTIFICATIONS,
      variables,
    });
    yield put(getNotificationsSuccess(response.data));
    yield put(updateChatCount(response.data.getWebNotifications.chatCount));
  } catch (error: unknown) {
    if (error instanceof Error) yield put(getNotificationsFailure(error.message));
  }
}

function* watchViewWebNotifications(action: PayloadAction<{ coachId: string }>) {
  try {
    const { coachId } = action.payload;
    const response = yield call(client.mutate, {
      mutation: VIEW_ALL_NOTIFICATIONS,
      variables: { coachId },
    });
    if (response.data.changeViewStatusWebNotifications.success) {
      yield put(viewWebNotificationsSuccess());
    }
  } catch (_error: unknown) {
    yield put(viewWebNotificationsFailure());
  }
}

export function* watchNotificationSagas() {
  yield takeLatest(getNotificationsRequest, watchGetNotifications);
  yield takeLatest(viewWebNotifications, watchViewWebNotifications);
}

const notificationSaga = watchNotificationSagas;
export default notificationSaga;
